import { matchPath } from 'react-router-dom';

// sayfa yüklenişinde, aktif route'un bulunduğu grup/alt-grup varsayılan
// olarak açık gelsin diye; subgroup çocukları da içeri girerek (recursive)
// kontrol edilir, çünkü Raporlar gibi iki seviyeli gruplarda aktif link
// bir alt-grubun (subgroup) içinde olabilir.
export default function hasActiveChild(children, pathname) {
  return Boolean(
    children?.some((child) =>
      child.type === 'subgroup'
        ? hasActiveChild(child.children, pathname)
        : child.url && !child.target && matchPath({ path: child.url, end: false }, pathname)
    )
  );
}
